export class DecryptedValue<T> {
  constructor(public readonly decryptedValue: T) {}
}
